var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"experience-wrapper--reviews-navbar"},[_c('el-container',[_c('div',{staticClass:"experience-wrapper--reviews-navbar-content"},[_c('LazyHydrate',{attrs:{"never":""}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }